// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

// --- RxJs
import { combineLatest, map } from 'rxjs';

// --- HS Code
import { OidcService, SurveyBaseService } from '../services';

// #endregion
export const manageRespondentsGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const oidcService: OidcService = inject(OidcService);
  const router: Router = inject(Router);
  const surveyService: SurveyBaseService = inject(SurveyBaseService);

  return combineLatest([
    oidcService.isMobileUser$,
    oidcService.isParticipant$,
    oidcService.isRespondent$
  ]).pipe(
    map(([isMobileUser, isParticipant, isRespondent]) => {
      if (isMobileUser) {
        return true;
      }

      if (!isParticipant) {
        if (isRespondent) {
          return router.createUrlTree(['/respondent']);
        } else {
          return router.createUrlTree(['/']);
        }
      }

      return router.createUrlTree(['/dashboard']);
    }
  ));
}
